import { render, staticRenderFns } from "./DistList.vue?vue&type=template&id=47ee2d48&"
import script from "./DistList.vue?vue&type=script&lang=js&"
export * from "./DistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports